/**
 * Toucan People — capture people you meet at events in seconds, then review
 * photos and "what we talked about" notes before the next one so you recognise
 * everyone. This boots the app. It opens the store and renders the shell, then
 * starts the blob uploads. `Shell.tsx` takes it from there.
 */

import { render } from "preact";
import { flushBlobs, toucan } from "toucan";
import { Shell } from "./Shell.tsx";
import { setApp } from "./state.ts";
import type { Person, ReviewStat, Tag } from "./model.ts";

/**
 * Open the store and put the app on the page — the whole of what loading this
 * module does, and the whole of what a browser needs from it.
 *
 * Exported for the tests, which boot the app once per test into a jsdom the
 * files in a worker share. A boot that is only a module's evaluation happens
 * once per module instance, and no test can insist on being given a new one:
 * see `boot()` in `test-helpers.ts` for what the shared registry does with
 * that.
 */
export async function main() {
  setApp(
    await toucan.open("people", {
      tags: [] as Tag[],
      people: [] as Person[],
      me: {},
      reviews: [] as ReviewStat[],
    }),
  );
  render(<Shell />, document.body);

  // Photos captured offline upload as soon as there is somewhere to put them.
  // The store makes the same pass every time the device wakes or comes back
  // online, and takes its listeners off again when it closes; this is only the
  // one at boot.
  void flushBlobs();
}

export const ready = main();
